module.exports = __webpack_public_path__ + "static/src/content/silks/trekking.60dcfd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/silks/trekking.png
// module id = VUPQ
// module chunks = 0